export const theme = {
  font: {
    default: "'Open Sans', 'Helvetica', sans-serif",
    alternate: "'Source Serif 4', serif",
    assistant: "'Assistant', sans-serif",
  },
  transition: {
    duration: {
      default: '300ms',
    },
    function: {
      default: 'ease-in-out',
    },
  },
  color: {
    tranparent: 'transparent',
    light: {
      default: 'white',
      tint: '#f8f8f8',
      tintDarker: '#f2f5f7',
      shadeLighter: '#f0f0f0',
      shade: '#d7dae0',
      whatsapp: '#FFFFFF',
    },
    medium: {
      default: '#8c96a3',
      tint: '#c5ccd6',
      shade: '#616b77',
    },
    dark: {
      default: '#707070',
      tint: '',
      shade: '#4d4d4d',
    },
    purple: {
      default: '#707070',
      tint: '#F8FAFE',
    },
    red: {
      default: '#ff453e',
      glass: 'rgba(255, 69, 62, .2)',
    },
    green: {
      default: '#03c9a9',
      glass: '#e4fdf0',
      whatsapp: '#25D366',
    },
    yellow: { default: '#ffcc01', tint: '#FFEECC' },
    blue: {
      default: '#091437',
      tint: '#00008b',
      glass: 'rgba(9,20,55,.2)',
      glassShade: 'rgba(9,20,55,.1)',
      darkerBlue: '#101a38',
      lightBlue: '#DDE6FB',
      light: '#F8FAFE',
      // lightBlue: '#748acf',
    },
    black: {
      default: '#000',
      whatsapp: '#103928',
    },
  },
};
